<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class BookingFieldsMixin extends Vue {
        @Prop({default: false, type: Boolean}) disableRequiredRule
        @Prop({default: false, type: Boolean}) disableBirthDateLimits

        isFieldMandatory(fieldKey) {
            return (
                runtimeStore.isTouristBookingField(fieldKey, 'MANDATORY', this.isMainTourist, this.isChild) ||
                (fieldKey === 'EMAIL' &&
                    this.isTourLead &&
                    (!authStore.person ||
                        runtimeStore.touristBookingFields.supplierConfigDetails?.tourLeadEmailRequired))
            )
        }

        isFieldDisabled(fieldKey) {
            return (
                runtimeStore.isTouristBookingFieldDisabled(fieldKey, this.isMainTourist, this.isChild) &&
                !this.isFieldMandatory(fieldKey)
            )
        }

        fieldLabel(token, fieldKey) {
            return `${this.$t(token)}${
                (fieldKey &&
                    this.isFieldMandatory(fieldKey) &&
                    !runtimeStore.isTouristNotRequired(this.tourist, this.isMainTourist)) ||
                (!fieldKey && !runtimeStore.isTouristNotRequired(this.tourist, this.isMainTourist))
                    ? '*'
                    : ''
            }`
        }

        requiredRule(token, fieldKey) {
            return v =>
                this.disableRequiredRule ||
                !!v ||
                (fieldKey && !this.isFieldMandatory(fieldKey)) ||
                runtimeStore.isTouristNotRequired(this.tourist, this.isMainTourist) ||
                `${this.$t(token)} ${this.$t('validation.required')}`
        }

        get isMainTourist() {
            return this.index === 0
        }

        get isTourLead() {
            return this.index === 0
        }

        get isChild() {
            return this.tourist.type === 'child'
        }

        get age() {
            return this.tourist.age
        }

        get date() {
            //TODO Need to add start date for all products
            return this.startDate ? this.$dateFns.parseISO(this.startDate) : new Date()
        }

        get minBirthDate() {
            return this.age && !this.disableBirthDateLimits
                ? this.$dateFns.format(this.$dateFns.add(this.$dateFns.subYears(this.date, +this.age + 1), {days: 1}))
                : '1900-01-01'
        }

        get maxBirthDate() {
            return this.age && !this.disableBirthDateLimits
                ? this.$dateFns.format(this.$dateFns.subYears(this.date, +this.age))
                : this.$dateFns.format(new Date())
        }
    }

    export default BookingFieldsMixin
</script>
